import React from 'react'
import './articles.css'
const TaxRegister = () => {
  return (
    <div class="articlecontainer">
    <header>
      <h1>How to Register Your Business with the General Directorate of Taxes in Albania</h1>
      <p>After registering your business and obtaining your <strong>Unique Business Identification Number (NIPT/NUIS)</strong>, the next essential step is registering with the <strong>General Directorate of Taxation</strong> (<em>Drejtoria e Përgjithshme e Tatimeve</em>). This process ensures your company is recognized as a taxpayer and allows you to manage tax obligations efficiently.</p>
    </header>

    <section class="step">
      <h2>Step 1: Understand Your Tax Responsibilities</h2>
      <p>Before registering your tax account, it’s important to know what tax obligations you will have as a business in Albania. These may include:</p>
      <ul>
        <li><strong>Value Added Tax (VAT)</strong> – Businesses with an annual turnover above <strong>10 million ALL</strong> must register for VAT.</li>
        <li><strong>Corporate Income Tax</strong> – Applied to businesses depending on their size and revenue.</li>
        <li><strong>Personal Income Tax</strong> – If you hire employees, you must withhold and pay personal income tax.</li>
        <li><strong>Social & Health Insurance Contributions</strong> – Employers must register employees and make mandatory contributions.</li>
      </ul>
      <p>Managing these taxes is done through the <strong>Albanian e-Filing system</strong>, where you will declare taxes, submit reports, and monitor your obligations.</p>
    </section>

    <section class="step">
      <h2>Step 2: Activate Your Tax Account</h2>
      <p>After one day from your business registration date, you can activate your tax account on the government tax portal:</p>
      <ul>
        <li>Go to: <strong>Albanian Tax e-Filing Portal</strong></li>
        <li>Click <strong>"Register"</strong> and enter your <strong>NIPT/NUIS</strong> number.</li>
        <li>Use the default initial password: <code>Tatimetemia12</code>.</li>
        <li>Change the password upon first login (make sure to save it securely).</li>
      </ul>
      <p><strong>Note:</strong> If you forget your password, you can reset it through your business account in <strong>e-Albania</strong>.</p>
    </section>

    <section class="step">
      <h2>Step 3: Start Managing Your Tax Obligations</h2>
      <p>Once your tax account is active, you can:</p>
      <ul>
        <li><strong>File tax declarations</strong> – Submit VAT, corporate tax, and income tax reports.</li>
        <li><strong>Register or remove employees</strong> – Manage payroll taxes and social security contributions.</li>
        <li><strong>Issue and manage invoices</strong> – If your business is VAT-registered, you must comply with electronic invoicing regulations.</li>
      </ul>
    </section>

    <footer>
      <p><strong>Final Thoughts:</strong> Registering with the <strong>General Directorate of Taxes</strong> is a critical step for legally operating your business in Albania. By activating your tax account, you ensure compliance with tax laws and gain access to essential online services.</p>
    </footer>
  </div>
  )
}

export default TaxRegister